import _extends from "@babel/runtime/helpers/extends";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject;

import React from 'react';
import { Alert } from 'antd';
import styled from 'styled-components';
var Warning = styled(Alert)(_templateObject || (_templateObject = _taggedTemplateLiteral(["&& {\n  margin: 10px 0px;\n  border: unset;\n  border-top: 5px solid #F7B125;\n  border-radius: unset;\n  & .ant-alert-message {\n    font-weight: 800;\n    font-size: 1.2rem;\n  }\n}"])));
export default (function (props) {
  return /*#__PURE__*/React.createElement(Warning, _extends({}, props, {
    type: "warning",
    showIcon: true
  }));
});